import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Vehicles from '../components/Vehicles';
import Pricing from '../components/Pricing';
import Benefits from '../components/Benefits';
import Gallery from '../components/Gallery';
import Reviews from '../components/Reviews';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Vehicles />
      <Benefits />
      <Pricing />
      <Gallery />
      <Reviews />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
